import type { SVGProps } from 'react'
const LineImagePlus = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M19.5 5V2.5H18V5h-2.5v1.5H18V9h1.5V6.5H22V5zm-3.885 5.325L11.5 14.44l-1.365-1.365a1.26 1.26 0 0 0-1.77 0L4.5 16.94V5.75c0-.69.56-1.25 1.25-1.25h7.75V3H5.75A2.755 2.755 0 0 0 3 5.75v12.5A2.755 2.755 0 0 0 5.75 21h12.5A2.755 2.755 0 0 0 21 18.25v-4.31l-3.615-3.615a1.26 1.26 0 0 0-1.77 0M19.5 18.25c0 .69-.56 1.25-1.25 1.25H5.75a1.25 1.25 0 0 1-1.075-.615L9.25 14.31l2.25 2.25 5-5 3 3zM8.5 11a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m0-1.5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineImagePlus }
